module.exports = {"data":{"markdownRemark":{"html":"<p>\"People who document histories of special people, places and events are selfless in the same way that are those who plant trees. The result is valued more by each future generation. Thank you for doing this.\"</p>","frontmatter":{"path":"/content/future-generations","year":"1990-1999","title":"Future Generations","image":null,"imagetitle":null,"author":"Dean Williams","publication":null}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/content-future-generations.json
// module id = 356
// module chunks = 90249615434571